import React from 'react';
import { useNavigate } from 'react-router-dom';

const FUNCTIONS = [
  { label: 'Sales Order',            icon: 'sales',      path: '/sales/orders' },
  { label: 'Purchase Order',         icon: 'purchase',    path: '/purchasing/orders' },
  { label: 'Item Master Data',       icon: 'item',        path: '/inventory/items' },
  { label: 'Business Partner',       icon: 'partner',     path: '/purchasing/vendors' },
  { label: 'MRP Wizard',             icon: 'mrp',         path: '/mrp/wizard' },
  { label: 'Order Recommendation',   icon: 'recommend',   path: '/mrp/recommendations' },
  { label: 'Production Order',       icon: 'production',  path: '/production/orders' },
];

export default function CommonFunctions() {
  const navigate = useNavigate();

  return (
    <div className="card">
      <div className="card-header">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B82F6"
          strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" />
        </svg>
        <span className="text-sm font-semibold text-sap-text">Common Functions</span>
      </div>

      <div className="grid grid-cols-4 sm:grid-cols-7 gap-2 p-4">
        {FUNCTIONS.map((fn) => (
          <button
            key={fn.label}
            onClick={() => navigate(fn.path)}
            className="flex flex-col items-center gap-2 px-2 py-3 rounded-xl border border-transparent
                       hover:bg-sap-blueLight hover:border-sap-border transition-all group"
          >
            <FunctionIcon name={fn.icon} />
            <span className="text-2xs text-sap-textLight text-center leading-tight group-hover:text-sap-blue font-medium">
              {fn.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

function FunctionIcon({ name }) {
  const wrap = 'w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center group-hover:bg-white transition-all';
  const props = { width: 20, height: 20, viewBox: '0 0 24 24', fill: 'none',
    stroke: '#6B7280', strokeWidth: 1.3, strokeLinecap: 'round', strokeLinejoin: 'round',
    className: 'group-hover:stroke-[#3B82F6] transition-colors' };

  let inner;
  switch (name) {
    case 'sales':
      inner = <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></>;
      break;
    case 'purchase':
      inner = <><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></>;
      break;
    case 'item':
      inner = <><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></>;
      break;
    case 'partner':
      inner = <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87m-4-12a4 4 0 010 7.75"/></>;
      break;
    case 'mrp':
      inner = <><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></>;
      break;
    case 'recommend':
      inner = <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 15l2 2 4-4"/></>;
      break;
    case 'production':
      inner = <><path d="M2 20h20M4 20V10l5-3v5l5-3v5l5-3v6"/><rect x="6" y="14" width="3" height="3"/><rect x="14" y="14" width="3" height="3"/></>;
      break;
    default:
      inner = <circle cx="12" cy="12" r="10"/>;
  }

  return (
    <div className={wrap}>
      <svg {...props}>{inner}</svg>
    </div>
  );
}
